import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import styles from '../styles'
import SectionHeader from './SectionHeader'
import CollectionCard from 'src/pages/collections/components/collection-card'
import { CoreButton } from 'src/components/core'
import useTrackerFunction from 'src/hooks/useTrackerFunction'

const CollectionSection = ({ classes, collections, isMobile }) => {
  const history = useHistory()
  const recentCollections = collections?.slice(0, 3) || []

  // Tracking functions
  const trackMoreCollections = useTrackerFunction('clicked_more_collections', {
    source: 'home_section',
  })
  const trackDiscoverCollection = useTrackerFunction(
    'clicked_discover_collection',
    {
      source: 'home_section',
    },
  )
  const trackCollectionClick = useTrackerFunction('clicked_collection_card', {
    source: 'home_section',
  })

  const handleMoreClick = () => {
    trackMoreCollections()
    history.push('/collections')
  }

  const handleDiscoverCollection = () => {
    trackDiscoverCollection()
    history.push('/collections')
  }

  const handleCollectionClick = collection => {
    trackCollectionClick({ collection_id: collection.id })
  }

  return (
    <Box className={classes.section}>
      <SectionHeader
        title="Recently created collections"
        link="/collections"
        linkText="More"
        onLinkClick={handleMoreClick}
      />

      {recentCollections.length === 0 ? (
        <Box className={classes.emptyState}>
          <Typography className={classes.emptyStateText}>
            <span className={classes.blueText}>
              Start create it by discovering
            </span>
            <br />
            your first collection.
          </Typography>
          <CoreButton onClick={handleDiscoverCollection} fullWidth={isMobile}>
            Discover collection
          </CoreButton>
        </Box>
      ) : (
        <Box className={classes.collectionsGrid}>
          {recentCollections.map(collection => (
            <CollectionCard
              key={collection.id}
              collection={collection}
              collections={recentCollections}
              refresh={() => {}}
              open={false}
              setOpen={() => {}}
              onClick={() => handleCollectionClick(collection)}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default withStyles(styles)(CollectionSection)
